/**
 * Ссылки «замена на» / «замена для» приходят из API как связи Payload: либо
 * раскрытым объектом запчасти, либо голой строкой-идентификатором, если связь
 * указывает в никуда (запчасть удалена или её id пришёл из staging-базы).
 *
 * Компоненты обращались к i.displayData напрямую, и одна такая строка роняла
 * рендер целиком — страница прибора оставалась пустой. Здесь нераскрытые связи
 * отбрасываются: показать замену всё равно нечем.
 */
export const populatedReplacements = <T extends { displayData?: any }>(
  list: unknown,
): T[] =>
  Array.isArray(list)
    ? (list.filter(
        (item) => item && typeof item === 'object' && (item as T).displayData,
      ) as T[])
    : [];

/** Первая активная замена, которую можно предложить вместо снятой с производства запчасти. */
export const pickReplacement = <T extends { displayData?: any }>(
  list: unknown,
): T | null =>
  populatedReplacements<T>(list).find(
    (item) =>
      item.displayData.status &&
      item.displayData.status !== 'discontinued' &&
      item.displayData.isActive,
  ) || null;
